<div class="camera-overlay" [class.camera-overlay--visible]="showOverlay$ | async">

  <!-- Always in DOM so the video element reference is stable -->
  <video #videoRef class="camera-overlay__video" autoplay muted playsinline></video>

  <!-- UI — only interactive when overlay is visible -->
  <div class="camera-overlay__ui">
    <div class="camera-overlay__header">
      <span class="camera-overlay__title">Apontar câmara para o código</span>
      <button class="camera-overlay__close" (click)="cancelScan()" aria-label="Fechar scanner">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>

    <div class="camera-overlay__frame">
      <div class="camera-overlay__corner camera-overlay__corner--tl"></div>
      <div class="camera-overlay__corner camera-overlay__corner--tr"></div>
      <div class="camera-overlay__corner camera-overlay__corner--bl"></div>
      <div class="camera-overlay__corner camera-overlay__corner--br"></div>
      <div class="camera-overlay__scan-line"></div>
    </div>

    <p class="camera-overlay__hint">Barcode · QR Code · EAN · Code128</p>
  </div>

</div>
